import { Component } from 'react';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values';
import { CPFValidator, emptyField, ErrorMessage, errorsLength, formatErrors, validateEmail, validatePasswordConfirmation } from '../../../../../../../../insfrastructure/utils/form-validators';
import { Input } from '../../../../../../../components/input';
import { Select } from '../../../../../../../components/select';
import birthdateIcon from '../../../../../../../../assets/icons/birthdate.png';
import documentIcon from '../../../../../../../../assets/icons/document.png';
import emailIcon from '../../../../../../../../assets/icons/email.png';
import fullPersonIcon from '../../../../../../../../assets/icons/full_person.png';
import passwordIcon from '../../../../../../../../assets/icons/password.png';
import profileIcon from '../../../../../../../../assets/icons/profile.png';
import './styles.sass';
import { PasswordRequirements } from '../../../../../../../components/password-requirements';

export class CompanyUserData extends Component<{form_data: Record<string, any>, onSubmit: (form: Record<string, any>) => void}> {

  state: any = {
    form: this.props.form_data,
    formErrors: {},
    genderOptions: [],
    showPassword: false
  }

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
        const genderOptions = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
        
        this.setState({ genderOptions });
      }, 1000);
    } catch (error) {}
  }

  onSubmit = () => {
    const errors = formatErrors({
      full_name: [emptyField(this.state.form.full_name, 'string')],
      date_of_birth: [emptyField(this.state.form.date_of_birth, 'string')],
      cpf: [CPFValidator(this.state.form.cpf)],
      manager_email: [validateEmail(this.state.form.manager_email)],
      gender: [emptyField(this.state.form.gender, 'string')],
      password: [emptyField(this.state.form.password, 'string')],
      password_confirmation: [validatePasswordConfirmation(this.state.form.password, this.state.form.password_confirmation)]
    });

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

    try {
        setTimeout(() => {
            this.setState({ sended: true });
            this.props.onSubmit(this.state.form);
        });
    } catch (error) {}
  }

  render() {
    return (
      <div className='form company-user'>
        <div className='form-container'>
          <div className='text'>
            <h4>Toda empresa precisa ter um perfil responsável por atualizá-la.</h4>
            <p>Este perfil administrador poderá deletar e conceder acesso de admin. para outros usuários que entrarem no nome da sua empresa e poderá editar o perfil da empresa.</p>
          </div>
          <div className='columns'>
            <div className='column'>
              <Input
              name='full_name'
              label='Nome Completo'
              icon={profileIcon}
              value={this.state.form.full_name}
              onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}/>
              <ErrorMessage errors={this.state.formErrors['full_name']} />
              <Input
              name='manager_email'
              label='E-Mail'
              icon={emailIcon}
              value={this.state.form.manager_email}
              onChange={e => this.setState({ form: { ...this.state.form, manager_email: e } })}/>
              <ErrorMessage errors={this.state.formErrors['manager_email']} />
              <Input
              name='cpf'
              label='CPF'
              icon={documentIcon}
              mask='999.999.999-99'
              value={this.state.form.cpf}
              onChange={e => this.setState({ form: { ...this.state.form, cpf: e } })}/>
              <ErrorMessage errors={this.state.formErrors['cpf']} />
              <Input
              name='date_of_birth'
              label='Data de Nascimento'
              type='date'
              icon={birthdateIcon}
              value={this.state.form.date_of_birth}
              onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}/>
              <ErrorMessage errors={this.state.formErrors['date_of_birth']} />
              <Select
              name='gender'
              label='Gênero'
              icon={fullPersonIcon}
              options={this.state.genderOptions}
              value={this.state.form.gender}
              onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}/>
              <ErrorMessage errors={this.state.formErrors['gender']} />
            </div>
            <div className='column'>
              <Input
              name='password'
              label='Senha'
              type='password'
              icon={passwordIcon}
              value={this.state.form.password}
              onChange={e => this.setState({ form: { ...this.state.form, password: e } })}/>
              <ErrorMessage errors={this.state.formErrors['password']} />
              <Input
              name='password_confirmation'
              label='Confirmar Senha'
              type='password'
              icon={passwordIcon}
              value={this.state.form.password_confirmation}
              onChange={e => this.setState({ form: { ...this.state.form, password_confirmation: e } })}/>
              <ErrorMessage errors={this.state.formErrors['password_confirmation']} />
              <PasswordRequirements
              password={this.state.form.password}
              email={this.state.form.manager_email}
              isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}/>
            </div>
        </div>
        <div className='submit-block'>
          <div>
            <p>
              Não se preocupe, suas informações estão seguras conosco. Seu CPF será usado para assegurar seu cadastro único e seus dados não serão compartilhado com os candidatos.
            </p>
          </div>
          <button className='primary' onClick={this.onSubmit}>Confirmar</button>
        </div>
        </div>
      </div>
    )
  }
}